// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\shared\\\\Tag\\\\Tag.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\shared\\Tag\\Tag.tsx");
  import.meta.hot.lastModified = "1757171103360.6035";
}
// REMIX HMR END

import { cn } from "~/lib/utils";
export function Tag({
  children,
  className
}) {
  return <span className={cn("inline-flex items-center h-9 px-4 rounded-full border border-dark-solid bg-transparent text-button-medium text-black transition-colors hover:bg-dark-10", className)}>
      {children}
    </span>;
}
_c = Tag;
var _c;
$RefreshReg$(_c, "Tag");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;